var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4999 5.14881C8.43999 5.14881 5.14875 8.44005 5.14875 12.5C5.14875 16.56 8.43999 19.8512 12.4999 19.8512C16.5599 19.8512 19.8511 16.56 19.8511 12.5C19.8511 8.44005 16.5599 5.14881 12.4999 5.14881ZM4.37494 12.5C4.37494 8.01269 8.01263 4.375 12.4999 4.375C16.9873 4.375 20.6249 8.01269 20.6249 12.5C20.6249 16.9873 16.9873 20.625 12.4999 20.625C8.01263 20.625 4.37494 16.9873 4.37494 12.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 12.5C17.4999 15.2614 15.2614 17.5 12.4999 17.5C9.73852 17.5 7.49994 15.2614 7.49994 12.5C7.49994 9.73858 9.73852 7.5 12.4999 7.5C15.2614 7.5 17.4999 9.73858 17.4999 12.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0001 13.125H20.6251V11.875H25.0001V13.125Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1249 -5.46392e-08L13.1249 4.375L11.8749 4.375L11.8749 0L13.1249 -5.46392e-08Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1249 20.625L13.1249 25L11.8749 25L11.8749 20.625L13.1249 20.625Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 13.125H0V11.875H4.375V13.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.39bd8459726caa2e83700e69ad3dabd0.svg";
export { ForwardRef as ReactComponent };